function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { cancelSubscriptionRenewal, closeConfirmation, getFullUserDetails, openConfirmation, openWriteToUs } from "@common/actions/index";
import { replaceWith } from "@common/services/helpers";
import { CANCEL_SUBSCRIPTION_FINAL_STEP, KEY_ENTER, KEY_SPACE, SMALL_MOBILE_TYPE_PX, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS, STATUS_CODE_SUCCESS, SUBSCRIPTION } from "@config/constants";
var OPTION_1;
var OPTION_2;
var OPTION_3;
var OPTION_4;
var OPTION_5;
var OPTION_6;
var OPTION_7;
var CancelSubscription = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(CancelSubscription, Component);
    var _super = _create_super(CancelSubscription);
    function CancelSubscription(props) {
        _class_call_check(this, CancelSubscription);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            otherReason: "",
            activeRadioButtonValue: props.additionalProps ? props.additionalProps.activeRadioButtonValue : null,
            serverError: "",
            cancellationPending: false
        };
        _this.cancelSubscriptionRenewal = _this.cancelSubscriptionRenewal.bind(_assert_this_initialized(_this));
        _this.handleChange = _this.handleChange.bind(_assert_this_initialized(_this));
        _this.openWriteToUsFromKeyboard = _this.openWriteToUsFromKeyboard.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(CancelSubscription, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var writeToUsLinks = document.getElementsByClassName("write-to-us-link");
                _to_consumable_array(writeToUsLinks).forEach(function(element) {
                    element.addEventListener("click", _this.props.openWriteToUs);
                    element.addEventListener("keydown", _this.openWriteToUsFromKeyboard);
                });
            }
        },
        {
            /**
     * Opens confirmation modal for subscription cancellation
     */ key: "openConfirmation",
            value: function openConfirmation(cancellationReason) {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, _$closeConfirmation = _this_props.closeConfirmation;
                this.props.openConfirmation({
                    message: i18n.account.areYouSureCancelSubscription,
                    declineMethod: _$closeConfirmation,
                    confirmMethod: function() {
                        return _this.cancelSubscriptionRenewal(cancellationReason);
                    },
                    declineButtonText: i18n.subscription.goBack
                });
            }
        },
        {
            key: "cancelSubscriptionRenewal",
            value: /**
     * Method that handles the cancellation of the subscription renewal
     */ function cancelSubscriptionRenewal(cancellationReason) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, _$cancelSubscriptionRenewal, _$getFullUserDetails, toggleComponent, _$closeConfirmation, enqueueSnackbar, i18n, response, error, errorText;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.state.cancellationPending) return [
                                    3,
                                    6
                                ];
                                _this_props = _this.props, _$cancelSubscriptionRenewal = _this_props.cancelSubscriptionRenewal, _$getFullUserDetails = _this_props.getFullUserDetails, toggleComponent = _this_props.toggleComponent, _$closeConfirmation = _this_props.closeConfirmation, enqueueSnackbar = _this_props.enqueueSnackbar, i18n = _this_props.i18n;
                                _$closeConfirmation();
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                _this.setState({
                                    cancellationPending: true
                                });
                                return [
                                    4,
                                    _$cancelSubscriptionRenewal(cancellationReason)
                                ];
                            case 2:
                                response = _state.sent();
                                if (!(response.status === STATUS_CODE_SUCCESS)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _$getFullUserDetails()
                                ];
                            case 3:
                                _state.sent();
                                enqueueSnackbar(i18n.snackbar.cancelSubscriptionSuccess, {
                                    variant: SNACKBAR_VARIANT_SUCCESS,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                toggleComponent(SUBSCRIPTION);
                                _this.setState({
                                    cancellationPending: false
                                });
                                _state.label = 4;
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                enqueueSnackbar(i18n.snackbar.cancelSubscriptionFail, {
                                    variant: SNACKBAR_VARIANT_ERROR,
                                    autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
                                });
                                _this.setState({
                                    cancellationPending: false
                                });
                                errorText = _this.props.i18n.errors["error".concat(error.subcode)];
                                _this.setState({
                                    serverError: errorText
                                });
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Opens writeToUs modal on enter/space keydown
     * @param event {Object}
     */ key: "openWriteToUsFromKeyboard",
            value: function openWriteToUsFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.props.openWriteToUs();
                }
            }
        },
        {
            /**
     * Renders radio button description.
     * @param value {String}
     * @param activeRadioButtonValue {String}
     * @param description {String}
     * @returns {DomElement}
     */ key: "renderDescription",
            value: function renderDescription(value, activeRadioButtonValue, description) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "radio-description".concat(activeRadioButtonValue == value ? " active" : ""),
                        children: description
                    })
                });
            }
        },
        {
            /**
     * Renders radio form control label.
     * @param value {String}
     * @returns {DomElement}
     */ key: "renderFormControlLabel",
            value: function renderFormControlLabel(value) {
                return /*#__PURE__*/ _jsx(FormControlLabel, {
                    value: value,
                    className: "radio-label",
                    control: /*#__PURE__*/ _jsx(Radio, {}),
                    label: value
                });
            }
        },
        {
            /**
     * Renders the inputs.
     * @returns {*}
     */ key: "renderInputs",
            value: function renderInputs() {
                var _this = this;
                var activeRadioButtonValue = this.state.activeRadioButtonValue;
                var i18n = this.props.i18n;
                OPTION_1 = i18n.account.temporaryCancel;
                OPTION_2 = i18n.account.noTvChannels;
                OPTION_3 = i18n.account.noQuality;
                OPTION_4 = i18n.account.highPrice;
                OPTION_5 = i18n.account.noDeviceApp;
                OPTION_6 = i18n.account.anotherSupplier;
                OPTION_7 = i18n.common.other;
                var writeToUsLink = '<span tabindex="0" class="blue-text write-to-us-link text-lowercase pointer">'.concat(i18n.writeToUs, "</span>");
                var subscriptionsLink = '<a href="/order/subscriptions"\n                                 class="blue-text pointer text-capitalize">'.concat(i18n.account.subscriptions, "</a>");
                var noTvChannelsDesc = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.account.noTvChannelsDesc, [
                            writeToUsLink,
                            subscriptionsLink
                        ])
                    }
                });
                var temporaryCancelDesc = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.account.temporaryCancelDesc, subscriptionsLink)
                    }
                });
                var noQualityDesc = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.account.noQualityDesc, writeToUsLink)
                    }
                });
                var highPriceDesc = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.account.highPriceDesc, subscriptionsLink)
                    }
                });
                var technicalProblem = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: replaceWith(i18n.account.technicalProblem, writeToUsLink)
                    }
                });
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(RadioGroup, {
                            "aria-label": "cancelation-reasons",
                            name: "cancelation-reasons",
                            className: "radio-group",
                            value: activeRadioButtonValue,
                            onChange: this.handleChange,
                            children: [
                                this.renderFormControlLabel(OPTION_1),
                                this.renderDescription(OPTION_1, activeRadioButtonValue, temporaryCancelDesc),
                                this.renderFormControlLabel(OPTION_2),
                                this.renderDescription(OPTION_2, activeRadioButtonValue, noTvChannelsDesc),
                                this.renderFormControlLabel(OPTION_3),
                                this.renderDescription(OPTION_3, activeRadioButtonValue, noQualityDesc),
                                this.renderFormControlLabel(OPTION_4),
                                this.renderDescription(OPTION_4, activeRadioButtonValue, highPriceDesc),
                                this.renderFormControlLabel(OPTION_5),
                                this.renderFormControlLabel(OPTION_6),
                                this.renderFormControlLabel(OPTION_7),
                                /*#__PURE__*/ _jsx(_Fragment, {
                                    children: /*#__PURE__*/ _jsx(TextField, {
                                        className: "ux-text-field-root radio-description".concat(activeRadioButtonValue == OPTION_7 ? " active" : ""),
                                        autoComplete: "off",
                                        InputProps: {
                                            className: "ux-input",
                                            classes: {
                                                error: "ux-input-error"
                                            },
                                            autoFocus: true,
                                            onChange: function(event) {
                                                return _this.setState({
                                                    otherReason: event.target.value
                                                });
                                            }
                                        },
                                        InputLabelProps: {
                                            classes: {
                                                root: "ux-input-label"
                                            }
                                        },
                                        id: "reason",
                                        type: "text",
                                        name: "reason",
                                        onChange: this.handleChange,
                                        margin: "none"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "write-to-us",
                            children: technicalProblem
                        })
                    ]
                });
            }
        },
        {
            /**
     * Change selected value
     * @param event
     */ key: "handleChange",
            value: function handleChange(event) {
                this.setState({
                    activeRadioButtonValue: event.target.value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, i18n = _this_props.i18n, toggleComponent = _this_props.toggleComponent, componentMap = _this_props.componentMap, componentName = _this_props.componentName;
                var _this_state = this.state, activeRadioButtonValue = _this_state.activeRadioButtonValue, otherReason = _this_state.otherReason;
                activeRadioButtonValue === OPTION_7 ? componentMap[componentName].childProps.activeRadioButtonValue = otherReason : componentMap[componentName].childProps.activeRadioButtonValue = activeRadioButtonValue;
                var parentProps = componentMap[componentName].parentProps;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "main-wrapper",
                    children: [
                        this.state.cancellationPending ? /*#__PURE__*/ _jsx("div", {
                            className: "loader centered-spinner"
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "cancel-subscription-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "we-are-sorry-title",
                                    children: i18n.account.weAreSorry
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    children: [
                                        i18n.account.shareWithUs,
                                        " (",
                                        i18n.account.notMandatory,
                                        ")."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    children: i18n.account.improveServices
                                }),
                                this.renderInputs()
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ _jsxs(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    onClick: function() {
                                        return toggleComponent(componentMap[componentName].parentComponentName, parentProps);
                                    },
                                    className: "go-back-button raised half-width float-left center-vertical",
                                    disabled: this.state.cancellationPending,
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-keyboard-arrow-right"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: i18n.account.goBack
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Button, {
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    onClick: function() {
                                        return _this.openConfirmation(activeRadioButtonValue);
                                    },
                                    className: "go-forward-button raised half-width float-right center-vertical",
                                    disabled: this.state.cancellationPending,
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: i18n.account.cancel
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-keyboard-arrow-right"
                                        })
                                    ]
                                }),
                                window.innerWidth >= SMALL_MOBILE_TYPE_PX ? /*#__PURE__*/ _jsxs(Button, {
                                    color: "primary",
                                    classes: {
                                        label: "ux-button-label"
                                    },
                                    className: "button-no-background write-to-us-button write-to-us-link center-vertical raised half-width float-right pointer",
                                    disabled: this.state.cancellationPending,
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "icon icon-contact-us"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: i18n.writeToUs
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CancelSubscription;
}(Component);
export default withSnackbar(connect(null, {
    openWriteToUs: openWriteToUs,
    openConfirmation: openConfirmation,
    closeConfirmation: closeConfirmation,
    getFullUserDetails: getFullUserDetails,
    cancelSubscriptionRenewal: cancelSubscriptionRenewal
})(CancelSubscription));
